export default __webpack_public_path__ + "static/media/future_events_icon.474a56f7.svg";